import React, { useCallback, useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useLanguage } from '../context/LanguageContext';
const images = [{
  src: 'https://cdn.magicpatterns.com/uploads/mrWkhM56hYj2u4H19u3N8R/IMAGEN_ANTES_Y_DESPUES_RECONPUESTA.png',
  alt: 'Antes y Después - Deck / Terraza'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/qQV631pEY7f2f9mmALkusb/imagen_1_antes_y_despues.png',
  alt: 'Before and After - Cancha de Tenis / Power Washing'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/c88o5HXt1kn69Wa37saFr3/IMEGEN_3_ANTES_Y_DESPUES.png',
  alt: 'Antes y Después - Baño / Remodelación'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/vhkPKqpVRdRaTuSySqneLY/IMAGEN_4_ANTES_Y_DESPUES.png',
  alt: 'Before and After - Concreto / Entrada'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/aPBt2cwHtHGapDzS2Z9bgS/ANTES_Y_DESPUES_5.png',
  alt: 'Antes y Después - Pisos / Floors'
}];
const slideVariants = {
  enter: (direction: number) => ({
    x: direction > 0 ? 300 : -300,
    opacity: 0,
    scale: 0.95
  }),
  center: {
    x: 0,
    opacity: 1,
    scale: 1
  },
  exit: (direction: number) => ({
    x: direction > 0 ? -300 : 300,
    opacity: 0,
    scale: 0.95
  })
};
export function BeforeAfterCarousel() {
  const [current, setCurrent] = useState(0);
  const [direction, setDirection] = useState(1);
  const [isAutoPlaying, setIsAutoPlaying] = useState(true);
  const {
    t
  } = useLanguage();
  const goTo = useCallback((index: number) => {
    setDirection(index > current ? 1 : -1);
    setCurrent(index);
  }, [current]);
  const next = useCallback(() => {
    setDirection(1);
    setCurrent(prev => (prev + 1) % images.length);
  }, []);
  const prev = useCallback(() => {
    setDirection(-1);
    setCurrent(prev => (prev - 1 + images.length) % images.length);
  }, []);
  useEffect(() => {
    if (!isAutoPlaying) return;
    const timer = setInterval(next, 5000);
    return () => clearInterval(timer);
  }, [isAutoPlaying, next]);
  return <section id="proyectos" className="py-16 bg-brand-bg-light" data-id="element-23">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-24">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} data-id="element-25">
          <div className="text-center mb-10" data-id="element-26">
            <h2 className="text-3xl sm:text-4xl md:text-5xl font-heading font-bold text-white mb-3" data-id="element-27">
              {t('carousel.title')}
            </h2>
            <p className="text-lg text-gray-400" data-id="element-28">{t('carousel.subtitle')}</p>
          </div>

          <div className="relative" onMouseEnter={() => setIsAutoPlaying(false)} onMouseLeave={() => setIsAutoPlaying(true)} data-id="element-29">
            {/* Main Image */}
            <div className="relative overflow-hidden rounded-2xl border-2 border-brand-gold/20 bg-brand-bg-dark aspect-[4/3] sm:aspect-[16/10]" data-id="element-30">
              <AnimatePresence custom={direction} mode="wait" data-id="element-31">
                <motion.img key={current} src={images[current].src} alt={images[current].alt} custom={direction} variants={slideVariants} initial="enter" animate="center" exit="exit" transition={{
                duration: 0.4,
                ease: 'easeInOut'
              }} className="absolute inset-0 w-full h-full object-cover" data-id="element-32" />
              </AnimatePresence>

              {/* Label */}
              <div className="absolute bottom-4 left-4 z-10" data-id="element-33">
                <span className="bg-brand-gold text-brand-bg-dark font-heading font-bold text-sm sm:text-base px-4 py-1.5 rounded-full uppercase tracking-wider shadow-lg" data-id="element-34">
                  {t('carousel.labels')[current]}
                </span>
              </div>

              {/* Counter */}
              <div className="absolute top-4 right-4 z-10" data-id="element-35">
                <span className="bg-black/60 text-white font-heading text-sm px-3 py-1 rounded-full" data-id="element-36">
                  {current + 1} / {images.length}
                </span>
              </div>

              {/* Prev / Next Arrows */}
              <button onClick={prev} className="absolute left-3 top-1/2 -translate-y-1/2 z-10 bg-black/50 hover:bg-black/80 text-white w-10 h-10 sm:w-12 sm:h-12 rounded-full flex items-center justify-center transition-colors" aria-label="Anterior" data-id="element-37">
                <svg className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2.5} data-id="element-38">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M15 19l-7-7 7-7" data-id="element-39" />
                </svg>
              </button>
              <button onClick={next} className="absolute right-3 top-1/2 -translate-y-1/2 z-10 bg-black/50 hover:bg-black/80 text-white w-10 h-10 sm:w-12 sm:h-12 rounded-full flex items-center justify-center transition-colors" aria-label="Siguiente" data-id="element-40">
                <svg className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2.5} data-id="element-41">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7" data-id="element-42" />
                </svg>
              </button>
            </div>

            {/* Dot Indicators */}
            <div className="flex justify-center gap-2 mt-6" data-id="element-43">
              {images.map((_, index) => <button key={index} onClick={() => goTo(index)} className={`w-3 h-3 rounded-full transition-all duration-300 ${index === current ? 'bg-brand-gold w-8' : 'bg-gray-600 hover:bg-gray-400'}`} aria-label={`Ir a imagen ${index + 1}`} data-id="element-44" />)}
            </div>

            {/* Thumbnails */}
            <div className="hidden sm:flex justify-center gap-3 mt-6" data-id="element-45">
              {images.map((img, index) => <button key={index} onClick={() => goTo(index)} className={`w-20 h-14 rounded-lg overflow-hidden border-2 transition-all duration-300 ${index === current ? 'border-brand-gold scale-110 shadow-lg shadow-brand-gold/20' : 'border-transparent opacity-50 hover:opacity-80'}`} data-id="element-46">
                  <img src={img.src} alt={img.alt} className="w-full h-full object-cover" data-id="element-47" />
                </button>)}
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}